import React from 'react';
import styled from '@emotion/styled';

import { getColor } from './UICommon';

import iosAppStoreIcon from '../../assets/iosAppStoreIcon.svg';
import androidPlayStoreIcon from '../../assets/androidPlayStoreIcon.svg';

interface GoToAppDesktopButtonProps {
  isAndroid?: boolean;
}

const GoToAppDesktopButton = styled.button`
  font-family: 'Poppins';
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  display: flex;
  align-items: center;
  border-radius: 100px;
  display: block;
  border: none;
  outline: none;
  padding: 14px 32px;
  width: ${(props: GoToAppDesktopButtonProps) => (props.isAndroid ? '242px' : '203px')};
  height: 52px;
  background: linear-gradient(91.86deg, ${getColor('PURPLE_60')} 0%, ${getColor('VIOLET_100')} 100%);
  color: ${getColor('WHITE')};
  cursor: pointer;
  &:disabled {
    background: ${getColor('GRAY_BG')};
    color: ${getColor('BLACK_60')};
  }
`;

const DivIButtons = styled.div`
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 469px;
  padding-bottom: 32px;
`;

const DivIButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const SpanText = styled.span`
  margin-left: 8px;
`;

interface GoToAppDesktopButtonsProps {
  desktopChangeButtonFunction: (isAndroid: boolean) => void;
}

export const GoToAppDesktopButtons = ({ desktopChangeButtonFunction }: GoToAppDesktopButtonsProps) => {
  return (
    <DivIButtons>
      <GoToAppDesktopButton id="iosAppStoreBtn" onClick={() => desktopChangeButtonFunction(false)} isAndroid={false}>
        <DivIButton>
          <img src={iosAppStoreIcon} alt="iosAppStoreIcon" />
          <SpanText>iOS App Store</SpanText>
        </DivIButton>
      </GoToAppDesktopButton>
      <GoToAppDesktopButton id="androidPlayStoreBtn" onClick={() => desktopChangeButtonFunction(true)} isAndroid={true}>
        <DivIButton>
          <img src={androidPlayStoreIcon} alt="androidPlayStoreIcon" />
          <SpanText>Android Play Store</SpanText>
        </DivIButton>
      </GoToAppDesktopButton>
    </DivIButtons>
  );
};
